import { Link } from "react-router-dom";
import { Search, Wrench, FileText, Link2, LineChart, Layers, Check, ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/Section";
import { useI18n } from "@/context/I18nContext";

const items = [
  { icon: Search, k: "seo.i1" }, { icon: FileText, k: "seo.i2" }, { icon: Wrench, k: "seo.i3" },
  { icon: Layers, k: "seo.i4" }, { icon: Link2, k: "seo.i5" }, { icon: LineChart, k: "seo.i6" },
];

export default function SeoPage() {
  const { t } = useI18n();
  return (
    <div>
      <section className="relative overflow-hidden grid-glow section-lux">
        <div className="absolute -top-32 right-0 h-96 w-96 rounded-full bg-amber-500/10 blur-[110px]" />
        <div className="container-lux relative text-center max-w-3xl">
          <div className="label-lux mb-3">{t("seo.label")}</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white">{t("seo.h1a")}<span className="gold-text">{t("seo.h1b")}</span></h1>
          <p className="mt-6 text-slate-400 text-lg leading-relaxed">{t("seo.sub")}</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/services/seo-growth" className="gold-btn" data-testid="seo-order-button">{t("seo.cta1")} <ArrowRight size={16} /></Link>
            <Link to="/contact" className="silver-btn">{t("seo.cta2")}</Link>
          </div>
        </div>
      </section>

      <section className="section-lux bg-[#0e1013] border-y border-amber-500/10">
        <div className="container-lux">
          <SectionHeading label={t("seo.secLabel")} title={t("seo.secTitle")} subtitle={t("seo.secSub")} />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((x, i) => (
              <div key={i} className="card-lux p-6 fade-up" style={{ animationDelay: `${i * 60}ms` }}>
                <x.icon className="text-amber-400 mb-4" size={24} />
                <h3 className="font-semibold text-white mb-2">{t(x.k + "t")}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{t(x.k + "d")}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 max-w-2xl mx-auto card-lux p-6">
            <h3 className="font-semibold text-white mb-3">{t("seo.incl")}</h3>
            <div className="grid sm:grid-cols-2 gap-2.5">
              {["seo.incl1", "seo.incl2", "seo.incl3", "seo.incl4"].map((f) => (
                <div key={f} className="flex items-center gap-2 text-sm text-slate-300"><Check size={15} className="text-amber-400" /> {t(f)}</div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
